// FORCE STATIC API URL
const API_BASE_URL = "https://msmeapi.digitransolutions.in/api";

class ApiService {
    async request(endpoint, method = "GET", body = null) {
        try {
            const response = await fetch(`${API_BASE_URL}${endpoint}`, {
                method,
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                mode: "cors",
                body: body ? JSON.stringify(body) : null,
            });

            const contentType = response.headers.get("content-type");
            const data = contentType?.includes("json")
                ? await response.json()
                : await response.text();

            if (!response.ok) {
                throw new Error(
                    `API Error (${response.status}): ${typeof data === "string" ? data : JSON.stringify(data)
                    }`
                );
            }

            return data;
        } catch (err) {
            throw new Error(`Request Failed: ${err.message}`);
        }
    }

    // APIs (NO QUERY STRINGS)
    getComplaints() {
        return this.request("/customers_complaint");
    }

    async submitComplaint(data) {
        const formatted = await this.transformFormData(data);

        // Submit to main API
        const result = await this.request("/customers_complaint", "POST", formatted);

        // Send to n8n webhook
        try {
            await fetch("https://n8n.digitransolutions.in/webhook/customers_complaint_intake_hook", { //https://n8n.digitransolutions.in/webhook/Customer_compliants_submission
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formatted),
            });
            console.log("Success");
        } catch (webhookError) {
            console.error("Failed to send to n8n webhook:", webhookError);
            // Don't throw error - webhook failure shouldn't block the main submission
        }

        return result;
    }

    getCustomers() {
        return this.request("/customers");
    }

    getProducts() {
        return this.request("/products");
    }

    getBatches() {
        return this.request("/batches");
    }

    // Transform before POST
    async transformFormData(formData) {
        const [products, batches] = await Promise.all([
            this.getProducts(),
            this.getBatches(),
        ]);

        const product = products.find(
            (p) => parseInt(p.product_id || p.id) === parseInt(formData.product_id)
        );

        const batch = batches.find(
            (b) => parseInt(b.batch_id || b.id) === parseInt(formData.batch_id)
        );

        // Create payload without ID - let the database auto-generate it
        const payload = {
            "Customer ID": formData.customer_id,
            "Contact Email": formData.customer_contact_details,
            "Product": product?.name || product?.product_name || formData.product_id,
            "Batch": batch?.batch_number || batch?.name || formData.batch_id,
            "Production Date": formData.production_date
                ? new Date(formData.production_date).toISOString()
                : null,
            "Defect Description": formData.defect_description,
            "Severity Level": formData.severity,
            "Business Impact": formData.business_impact,
            "Cost Estimate (USD)": formData.cost_estimate
                ? parseFloat(formData.cost_estimate)
                : null,
            "Status": formData.status || "Reported",
            "Previous Complaint ID": formData.previous_complaint_id
                ? parseInt(formData.previous_complaint_id)
                : null,
            "Linked Issue ID": formData.linked_issue_id
                ? parseInt(formData.linked_issue_id)
                : null,
            "Is Repeat Defect": Boolean(formData.is_repeat),
            "Submission Timestamp": new Date().toISOString()
        };

        return payload;
    }
}

const apiServiceInstance = new ApiService();
export default apiServiceInstance;
